import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CategoryService } from 'src/app/api/catalog/category.service';
import { GlobalService } from 'src/app/api/global.service';
import { IncomeService } from 'src/app/api/money/income.service';
import { CitietouristicService } from 'src/app/api/tourism/citietouristic.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import { constants } from 'src/app/constants';
import * as moment from 'moment';
import { ToolsService } from 'src/app/utils/tools.service';
import { VoucherCancelledExtendsComponent } from 'src/app/billing/voucher/voucher-cancelled-extends/voucher-cancelled-extends.component';
declare var $: any;

@Component({
  selector: 'app-income-list',
  templateUrl: './income-list.component.html',
  styleUrls: ['./income-list.component.css']
})
export class IncomeListComponent implements OnInit{
  @ViewChild(VoucherCancelledExtendsComponent) VoucherCancelledExtendsComponent: any;
  private thisComponent: IncomeListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  start_range:any = moment().startOf('month');
  end_range:any = moment().endOf('month');

  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_ingreso: any = null;
  typedocument_ruc: any = null;

  constructor(
    private router: Router,
    private incomeService: IncomeService,
    private globalService: GlobalService,
    private alert: SwalAlert,
    public toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.thisComponent = this;

    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_ingreso = this.toolsService.searchObjByKey(
      'RECIBO_INGRESO',
      constants.SALE.VOUCHER
    );

  }

  ngOnInit() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker({
      locale: {
        format: 'YYYY-MM-DD'
      },
      startDate: component_.start_range,
      endDate: component_.end_range,
      showDropdowns: true,
    },
      function(chosen_date: any) {
        // (<any>$('#date_arrival')).val( chosen_date.format('YYYY-MM-DD'));
        // component_.setDateArrival(chosen_date.format('YYYY-MM-DD'));
      }  
    );

    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page + '&branchofficeSlug='+this.branchofficeSlug
    "&start_range=" + this.start_range.format('YYYY-MM-DD') + '&end_range=' + this.end_range.format('YYYY-MM-DD');
    this.incomeService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total; 
        console.log(this.items);       
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/turismo/ciudades/editar',
      id
    ]);
  }

  delete(item: any) {
    let options = {
      title: '¿Estás segur@ de anular el movimiento de ingreso?',
      message: item.nro_voucher,
      cancel: 'Cancelar',
      confirm: 'Sí, ANULAR'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.incomeService.delete(item.id).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('El registro '+item.nro_voucher+' se ha anulado con éxito');
            this.list();
          }
        });
      }
    });
  }

  extendsVoucherCancelled(event: any): void {
    this.list();
  }

}
